import { Form, Formik } from 'formik';
import { InputField } from 'components/Formik/InputField';
import { css } from '@linaria/core';
import { baseTheme } from 'styles/utils';
import { formatCentsToDollars, formatDollarsToCents } from 'utils/pricing';
import cogoToast from 'components/ToastMessage/ToastMessage';
import { PaymentMethod } from '../PaymentMethod';
import { AutoRechargeFormValues, AutoRechargeModalProps } from './type';
import { autoRechargeValidationSchema } from './formSchemaValidation';
import { isTopUpConfigChange, sanitizeInputNumber } from './utils';
import { useCreditAutoTopUp } from '../hooks/useCreditAutoTopUp';
import { useEditCreditCard } from '../hooks/useEditCreditCard';
import { ModalHeader } from './ModalHeader';
import { ModalFooter } from './ModalFooter';
export const AutoRechargeModal = ({
  onClose,
  onConfirm
}: AutoRechargeModalProps) => {
  const {
    createOrUpdateAutoTopUp,
    autoTopUpConfig,
    isCreatingAutoTopUp
  } = useCreditAutoTopUp();
  const {
    updateCreditCardIfNeeded
  } = useEditCreditCard();
  const balanceThreshold = autoTopUpConfig?.threshold_amount_cents ? formatCentsToDollars(Number(autoTopUpConfig?.threshold_amount_cents))?.toString() : '';
  const rechargeAmount = autoTopUpConfig?.top_up_amount_cents ? formatCentsToDollars(Number(autoTopUpConfig?.top_up_amount_cents))?.toString() : '';
  const handleTopUpConfigChanges = (values: AutoRechargeFormValues): void => {
    createOrUpdateAutoTopUp({
      topAmount: Number(values.rechargeAmount),
      thresholdAmount: Number(values.balanceThreshold)
    }, {
      onSuccess: () => {
        cogoToast.success('Auto recharge settings saved successfully');
        onConfirm?.(values);
      },
      onError: () => {
        cogoToast.error('Failed to save Auto recharge settings. Please try again.');
      }
    });
  };
  const handleFormSubmit = async (values: AutoRechargeFormValues) => {
    try {
      await updateCreditCardIfNeeded(values?.creditCard);
      const newBalanceThreshold = Number(values.balanceThreshold);
      const newRechargeAmount = Number(values.rechargeAmount);
      handleTopUpConfigChanges({
        ...values,
        balanceThreshold: formatDollarsToCents(newBalanceThreshold)?.toString(),
        rechargeAmount: formatDollarsToCents(newRechargeAmount - newBalanceThreshold)?.toString()
      });
    } catch {
      cogoToast.error('Failed to update payment method. Please try again.');
    }
  };
  const handleInputChange = (fieldName: string, value: string, setFieldValue: (field: string, value: string) => void) => {
    const sanitizedValue = sanitizeInputNumber(value);
    setFieldValue(fieldName, sanitizedValue);
  };
  return <div className={container}>
      <ModalHeader onClose={onClose} title="Auto recharge settings" />
      <Formik initialValues={{
      balanceThreshold,
      rechargeAmount,
      creditCard: {
        value: '',
        name: '',
        content: <></>,
        metaData: ({} as CF.API.Users.Card)
      }
    }} onSubmit={handleFormSubmit} validationSchema={autoRechargeValidationSchema} enableReinitialize>
        {({
        isValid,
        values,
        setFieldValue
      }) => {
        return <Form>
              <div className="payment-method">
                <>
                  <InputField name="balanceThreshold" label="When the credit balance reaches" type="text" id="balance-threshold" required LeftIcon={<span className="currency">$</span>} onChange={e => handleInputChange('balanceThreshold', e.target.value, setFieldValue)} />
                  <InputField name="rechargeAmount" label="Bring credit balance back up to" type="text" id="recharge-amount" required LeftIcon={<span className="currency">$</span>} onChange={e => handleInputChange('rechargeAmount', e.target.value, setFieldValue)} />
                  <PaymentMethod label="Select Payment Method" required selectedPaymentMethodId={values.creditCard?.value} onPaymentMethodChange={card => {
                setFieldValue('creditCard', card);
              }} />
                </>
              </div>

              <ModalFooter isLoading={isCreatingAutoTopUp} onClose={onClose} isConfirmDisable={!isValid || !isTopUpConfigChange(balanceThreshold, rechargeAmount, values)} confirmText="Save Settings" showPricingLink={false} />
            </Form>;
      }}
      </Formik>
    </div>;
};
export const container = "odules__User__components__Settings__Billing__AutoRecharge__AutoRechargeModal_tsx-container-c1modjdu";

require("./AutoRechargeModal.linaria.module.css!=!../../../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./AutoRechargeModal.tsx");